import React from 'react';
import AppLayout from '../components/layout/AppLayout';
import { TransportCalculator } from '../App';

export default function ShipmentNew() {
  return (
    <AppLayout title="New Shipment">
      <div className="max-w-7xl mx-auto">
        <TransportCalculator embedded showBulkTab={false} showDashboard={false} />
      </div>
    </AppLayout>
  );
}
